import { Rule } from 'antd/lib/form';

export const name: Rule[] = [
  {
    required: true,
    message: 'O nome é obrigatório',
  },
];

export const password = [
  {
    required: true,
    message: 'A senha é obrigatória',
  },
];

export const passwordConfirm: Rule[] = [
  {
    required: true,
    message: 'A confirmação de senha é obrigatória',
  },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') !== value) {
        return Promise.reject(new Error('As duas senhas não coincidem'));
      }
      return Promise.resolve();
    },
  }),
];
